import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__loyalty-transactions',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__loyalty-transactions .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__loyalty-scenario',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__loyalty-scenario .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__analytics-other-technologies',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__analytics-other-technologies .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__analytics-other-technologies',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__analytics-other-technologies .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);


});



// WEBPACK FOOTER //
// ./app/scripts/pages/technologies/loyalty.js